
import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

export default function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (sectionId: string) => {
    if (location.pathname !== '/') {
      // If not on home page, navigate to home first
      navigate('/');
      // Wait for navigation to complete, then scroll
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }, 100);
    } else {
      // If on home page, just scroll
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
      isScrolled ? 'bg-[#2C1810] shadow-lg' : 'bg-transparent'
    }`}>
      <div className="w-full px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          {/* Logo - Left aligned */}
          <button 
            onClick={() => navigate('/')}
            className="cursor-pointer hover:opacity-80 transition-opacity"
          >
            <img 
              src="https://static.readdy.ai/image/77dfda70a227b79a5ca6ebe791df28a2/ac0c68493b0c85fe164001f996b36c2f.png" 
              alt="FTK Logo" 
              className="h-12 w-auto"
            />
          </button>

          {/* Navigation Links - Right aligned */}
          <div className="flex items-center gap-8">
            <button 
              onClick={() => handleNavClick('home')}
              className="font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#D4A574]"
            >
              Home
            </button>
            <button 
              onClick={() => handleNavClick('mission')}
              className="font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#D4A574]"
            >
              Mission
            </button>
            <button 
              onClick={() => handleNavClick('subsidiaries')}
              className="font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#D4A574]"
            >
              Subsidiaries
            </button>
            <button 
              onClick={() => handleNavClick('calendar')}
              className="font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#D4A574]"
            >
              Calendar
            </button>
            <button 
              onClick={() => navigate('/blog')}
              className="font-medium transition-colors cursor-pointer whitespace-nowrap text-white hover:text-[#D4A574]"
            >
              Blog
            </button>
            <button 
              onClick={() => handleNavClick('contact')}
              className="px-6 py-2.5 bg-[#D4A574] text-[#2C1810] font-semibold hover:bg-white transition-colors cursor-pointer whitespace-nowrap border-2 border-[#D4A574]"
            >
              Contact
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
